import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { Container, SinglePageBucket, NavLinkAsA } from './site-footer-css';


const FooterWrapper = ({ singlePages }) => (
  <Container>
    <div>
      ©&nbsp;
      {new Date().getFullYear()}
      &nbsp;CME Group. All rights reserved.
    </div>
    {singlePages && singlePages.length > 0 && (
      <SinglePageBucket>
        {singlePages.map(({ title, slug }) => (
          <NavLinkAsA key={slug} href={`/${slug}`} target="_blank">{title}</NavLinkAsA>
        ))}
      </SinglePageBucket>
    )}
  </Container>
);

FooterWrapper.propTypes = {
  singlePages: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  })),
};

FooterWrapper.defaultProps = {
  singlePages: null,
};

const FooterWithQuery = (props) => {
  const { contentfulNavigation } = useStaticQuery(graphql`
    query {
      contentfulNavigation(title: {eq: "Legal"}) {
        links {
          title
          slug
        }
      }
    }
  `);

  return (
    <FooterWrapper
      singlePages={contentfulNavigation ? contentfulNavigation.links : null}
      {...props}
    />
  );
};

export default FooterWithQuery;
